module.exports = __webpack_public_path__ + "fc1e815a313f6e16726ccfb69c14af05.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/pineapple-s.png
// module id = 2086
// module chunks = 0